"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostTenantResponse = instanceOfApiPostTenantResponse;
exports.ApiPostTenantResponseFromJSON = ApiPostTenantResponseFromJSON;
exports.ApiPostTenantResponseFromJSONTyped = ApiPostTenantResponseFromJSONTyped;
exports.ApiPostTenantResponseToJSON = ApiPostTenantResponseToJSON;
exports.ApiPostTenantResponseToJSONTyped = ApiPostTenantResponseToJSONTyped;
const ApiTenant_1 = require("./ApiTenant");
/**
 * Check if a given object implements the ApiPostTenantResponse interface.
 */
function instanceOfApiPostTenantResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('tenant' in value) || value['tenant'] === undefined)
        return false;
    return true;
}
function ApiPostTenantResponseFromJSON(json) {
    return ApiPostTenantResponseFromJSONTyped(json, false);
}
function ApiPostTenantResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'tenant': (0, ApiTenant_1.ApiTenantFromJSON)(json['tenant']),
    };
}
function ApiPostTenantResponseToJSON(json) {
    return ApiPostTenantResponseToJSONTyped(json, false);
}
function ApiPostTenantResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'tenant': (0, ApiTenant_1.ApiTenantToJSON)(value['tenant']),
    };
}
